import { createSlice } from "@reduxjs/toolkit";
import { ArticleProps } from "./Article";

const initialState: ArticleProps.State = {
  draftArticle: {} as ArticleProps.Article,
  draftArticleList: [],
  publishedArticleList: [],
  scheduledArticleList: [],
  createDraftAPI_STATUS: "idle",
};
const slice = createSlice({
  name: "article",
  initialState,
  reducers: {
    setCreateDraftAPI_STATUS: (
      state,
      action: ArticleProps.setCreateDraftAPI_STATUS
    ) => {
      state.createDraftAPI_STATUS = action.payload;
    },
    setArticleDraftList: (state, action: ArticleProps.setArticleDraftList) => {
      state.draftArticleList = action.payload;
    },
    setArticleScheduledList: (
      state,
      action: ArticleProps.setArticleDraftList
    ) => {
      state.scheduledArticleList = action.payload;
    },
    setArticlePublishedList: (
      state,
      action: ArticleProps.setArticleDraftList
    ) => {
      state.publishedArticleList = action.payload;
    },
    setArticleDraft: (state, action: ArticleProps.setArticleDraft) => {
      state.draftArticle = action.payload;
    },
    setArticleContent: (state, action: ArticleProps.setArticleContent) => {
      const { row_config, id } = action.payload;
      if (row_config.element_role === "cover_image") {
        state.draftArticle.cover_image = action.payload;
      } else if (row_config.element_role === "title") {
        state.draftArticle.title_content = action.payload;
      } else {
        if ((state.draftArticle.body_content_order || []).includes(id)) {
          state.draftArticle.body_content = state.draftArticle.body_content.map(
            (content) => (content.id === id ? action.payload : content)
          );
        } else {
          state.draftArticle.body_content = [
            ...state.draftArticle.body_content,
            action.payload,
          ];
          state.draftArticle.body_content_order = [
            ...(state.draftArticle.body_content_order || []),
            id,
          ];
        }
      }
    },
    setBodyContentOrder: (state, action: ArticleProps.setBodyContentOrder) => {
      state.draftArticle.body_content = action.payload;
    },
    deleteArticleContent: (
      state,
      action: ArticleProps.deleteArticleContent
    ) => {
      state.draftArticle.body_content = state.draftArticle.body_content.filter(
        (content) => content.id !== action.payload
      );
      state.draftArticle.body_content_order =
        state.draftArticle.body_content_order.filter(
          (id) => id !== action.payload
        );
    },
    deleteArticleDraft: (state, action: ArticleProps.deleteArticleDraft) => {
      state.draftArticleList = state.draftArticleList.filter(
        (article) => article.id !== action.payload
      );
    },
    deleteScheduledArticleDraft: (
      state,
      action: ArticleProps.deleteArticleDraft
    ) => {
      state.scheduledArticleList = state.scheduledArticleList.filter(
        (article) => article.id !== action.payload
      );
    },
    deletePublishedArticleDraft: (
      state,
      action: ArticleProps.deleteArticleDraft
    ) => {
      state.publishedArticleList = state.publishedArticleList.filter(
        (article) => article.id !== action.payload
      );
    },
    setImageGalleryOrder: (
      state,
      action: ArticleProps.setImageGalleryOrder
    ) => {
      const { id, imageList } = action.payload;
      state.draftArticle.body_content = state.draftArticle.body_content.map(
        (article) =>
          article.id === id
            ? ({
                ...article,
                content_data: imageList,
              } as ArticleProps.WithImageContent)
            : article
      );
    },
    deleteArticleImage: (state, action: ArticleProps.deleteArticleImage) => {
      const { id, image_id } = action.payload;
      state.draftArticle.body_content = state.draftArticle.body_content.map(
        (article) =>
          article.id === id
            ? ({
                ...article,
                content_data: (
                  article as ArticleProps.WithImageContent
                ).content_data.filter((image) => image.id !== image_id),
              } as ArticleProps.WithImageContent)
            : article
      );
    },
    reset: () => initialState,
  },
});

export const articleActions = slice.actions;
export const articleReducer = slice.reducer;
